import fetchApi from "./fetchApi";

const ROOT = process.env.REACT_APP_TDX_API_URL;


/*取得指定縣市的巴士路線 */

export const fetchBusRoutesByCity = (City) =>
  fetchApi(`${ROOT}/Bus/Route/City/${City}`);


/*取得指定縣市和路線名稱的巴士路線站牌 */

export const fetchStopsByRoute = (
  City = "Taipei",
  RouteName = "307",
) =>
  fetchApi(`${ROOT}/Bus/StopOfRoute/City/${City}/${RouteName}`);

  /*取得指定縣市和路線名稱的公車各站到站時間 */

export const fetchArrivalTimeByRoute = (
  City = "Taipei",
  RouteName = "307",
) =>
  fetchApi(`${ROOT}/Bus/EstimatedTimeOfArrival/City/${City}/${RouteName}`);

  /*取得指定縣市和路線名稱的公車之路線形狀*/

  export const fetchShapeByRoute = (
    City = "Taipei",
    RouteName = "307",
  ) =>
    fetchApi(`${ROOT}/Bus/Shape/City/${City}/${RouteName}`);